import $x from '@/utils/$x';

// iDong 推送 - 录播课推送列表分页查询
export const pageIdongRecordCourses = (params) => {
  return $x.post('/idong/record-course/page', params);
};

// iDong 推送 - 录播课推送内容详情
export const getIdongRecordCourseDetail = (idongCourseId) => {
  return $x.post('/idong/record-course/detail', {
    requestData: { idongCourseId },
  });
};

// iDong 推送 - 录播课单条/批量重新推送（requestId 幂等，前端生成 UUID）
export const repushIdongRecordCourses = (requestId, courseIds) => {
  return $x.post('/idong/record-course/repush', {
    requestData: { requestId, courseIds },
  });
};

// 生成请求幂等 ID
export const genRequestId = () => {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
